import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
`
<div>
    <p><strong>Description - DG Label Defect</strong></p>
    <p>Issue with Dangerous Goods Label reported on ZBR Bag, that will be departed soon.</p>

    <p><strong>Impact</strong></p>
    <p>Unlabelled ZBR bags are not compliant according to agreement concerning the International Carriage of Dangerous Goods.</p>

    <p><strong>Resolution Steps</strong></p>
    <ol>
        <li>Check the list of defective DG labels in ‘Additional Details’ that is required. Take these labels from the Problem Solve area.</li>
        <li>Identify the staging location of the defective bag using the Planned Staging Location in ‘Additional Details’. Incase you aren't able to find the cart, refer to Pick tab link below in SCC to validate the actual staging location.</li>
        <li>Walk to the staging location and visually identify the defective bag. Do not attempt to remove the bag from the cart.</li>
        <li>Use the replacement labels and stick them onto the defective bag.</li>
    </ol>

    <p><strong>Helpful Links</strong></p>
    <ol>
        <li>
            <span class="wikiinternallink">
                <a rel="noopener noreferrer" target="_blank" href="https://w.amazon.com/bin/view/EU-Hazmat/Home/Eudgintake">
                    EU Dangerous Goods Operations Wiki
                </a>
            </span>
        </li>
        <li>
            <span class="wikiinternallink">
                <a rel="noopener noreferrer" target="_blank" href="https://policy.a2z.com/docs/668183/publication">
                    Pick and Stage Problem Solve SOP
                </a>
            </span>
        </li>
        <li>
            <span class="wikiinternallink">
                Pick tab: <a href="https://logistics.amazon.co.uk/station/dashboard/pick" target="_blank">
                    https://logistics.amazon.co.uk/station/dashboard/pick
                </a>
            </span>
        </li>
    </ol>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Defective_DG_Label.jsx